export default __webpack_public_path__ + "3677149788636fe99bc9bff33f065270.svg";